import { heading, text, button, image, divider, spacer, social, footerBlk, headerBar, columns, hero } from './builders'

const FOOTER = footerBlk(
  'You are receiving this email because you shopped with <strong>Nimbus&nbsp;Store</strong>.<br/>' +
  'Nimbus Store, 4400 Commerce Blvd, Suite 210, Austin, TX 78701<br/>' +
  '<a href="{{unsubscribe_url}}" style="color:#8a94a6;text-decoration:underline;">Unsubscribe</a> &nbsp;&bull;&nbsp; ' +
  '<a href="{{preferences_url}}" style="color:#8a94a6;text-decoration:underline;">Email preferences</a>',
  { backgroundColor: '#f4f6fb', color: '#8a94a6', fontSize: '12' }
)

const HEADER = headerBar({
  desktopLayout: 'logo_inline',
  logoAlignment: 'left',
  backgroundColor: '#ffffff',
  linkColor: '#5b6472',
  links: [
    { id: 'l1', kind: 'link', label: 'Shop', url: 'https://nimbusstore.example/shop' },
    { id: 'l2', kind: 'link', label: 'Orders', url: 'https://nimbusstore.example/orders' },
    { id: 'l3', kind: 'link', label: 'Help', url: 'https://nimbusstore.example/help' }
  ],
  paddingTop: 18,
  paddingBottom: 18
})

const TEMPLATES = [
  {
    id: 'ecommerce-order-confirmation',
    category: 'ecommerce',
    name: 'Order Confirmation',
    description: 'Thanks the shopper and confirms the order with an itemized summary and total.',
    blocks: [
      HEADER,
      hero('Order confirmed', '059669', 'ffffff', {}),
      heading('Thanks, $first_name — your order is confirmed!', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '28',
        paddingBottom: '8'
      }),
      text(
        'We are getting your items ready. Your order <strong>#$order_id</strong> has been received and payment confirmed. ' +
        'You will get another email the moment it ships.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('12'),
      button('View your order', 'https://nimbusstore.example/orders/$order_id', {
        backgroundColor: '#2563eb',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '30',
        buttonPaddingV: '14'
      }),
      spacer('20'),
      heading('Order summary', {
        fontSize: '16',
        fontWeight: '700',
        alignment: 'left',
        color: '#059669',
        backgroundColor: '#ecfdf5',
        paddingLeft: '24',
        paddingTop: '10',
        paddingBottom: '10'
      }),
      text(
        '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">' +
        '<tr>' +
        '<td style="padding:10px 0;border-bottom:1px solid #eceef3;color:#1b2333;">Aurora Wireless Headphones <span style="color:#8a94a6;">&times;1</span></td>' +
        '<td style="padding:10px 0;border-bottom:1px solid #eceef3;text-align:right;color:#1b2333;">$129.00</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="padding:10px 0;border-bottom:1px solid #eceef3;color:#1b2333;">Nimbus USB-C Charging Cable <span style="color:#8a94a6;">&times;2</span></td>' +
        '<td style="padding:10px 0;border-bottom:1px solid #eceef3;text-align:right;color:#1b2333;">$24.00</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="padding:10px 0;color:#8a94a6;">Shipping</td>' +
        '<td style="padding:10px 0;text-align:right;color:#8a94a6;">Free</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="padding:14px 0 0;font-weight:700;color:#1b2333;">Total</td>' +
        '<td style="padding:14px 0 0;text-align:right;font-weight:700;color:#1b2333;">$order_total</td>' +
        '</tr>' +
        '</table>',
        { color: '#1b2333', fontSize: '14', alignment: 'left', lineHeight: '1.5', paddingLeft: '24', paddingRight: '24', paddingTop: '4' }
      ),
      spacer('16'),
      text(
        'Shipping to $first_name — a confirmation with tracking follows once your parcel leaves our warehouse. ' +
        'Questions? Just reply to this email and our team will help.',
        { color: '#5b6472', fontSize: '13', alignment: 'left', lineHeight: '1.6', paddingLeft: '24', paddingRight: '24' }
      ),
      spacer('20'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  },

  {
    id: 'ecommerce-shipping-out-for-delivery',
    category: 'ecommerce',
    name: 'Shipping / Out for Delivery',
    description: 'Lets the shopper know their order is on the way with a live tracking CTA.',
    blocks: [
      HEADER,
      hero('Your order is on the way', '059669', 'ffffff', {}),
      heading('Good news, $first_name — it is out for delivery!', {
        fontSize: '24',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '26',
        paddingBottom: '8'
      }),
      text(
        'Order <strong>#$order_id</strong> has left our warehouse and is scheduled to arrive today. ' +
        'Keep an eye out — you can follow every stop in real time below.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('12'),
      text(
        '<span style="color:#8a94a6;">Tracking number</span><br/>' +
        '<strong style="font-size:18px;color:#059669;letter-spacing:1px;">$tracking_id</strong>',
        { color: '#1b2333', fontSize: '14', alignment: 'center', lineHeight: '1.6', backgroundColor: '#ecfdf5', paddingTop: '14', paddingBottom: '14' }
      ),
      spacer('14'),
      button('Track my package', 'https://nimbusstore.example/track/$tracking_id', {
        backgroundColor: '#059669',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '32',
        buttonPaddingV: '14'
      }),
      spacer('20'),
      text(
        'Not going to be home? You can redirect the delivery or leave delivery instructions from your ' +
        '<a href="https://nimbusstore.example/orders/$order_id" style="color:#2563eb;">order page</a>.',
        { color: '#5b6472', fontSize: '13', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('18'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  },

  {
    id: 'ecommerce-abandoned-cart',
    category: 'ecommerce',
    name: 'Abandoned Cart',
    description: 'Reminds the shopper about a left-behind item and nudges them to complete checkout.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#5b6472',
        links: [
          { id: 'l1', kind: 'link', label: 'Shop', url: 'https://nimbusstore.example/shop' },
          { id: 'l2', kind: 'link', label: 'Bag', url: 'https://nimbusstore.example/cart' },
          { id: 'l3', kind: 'link', label: 'Help', url: 'https://nimbusstore.example/help' }
        ],
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('Still in your bag', 'f97316', 'ffffff', {}),
      heading('You left something behind, $first_name', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '28',
        paddingBottom: '8'
      }),
      text(
        'Your <strong>$product_name</strong> is still waiting in your bag — but popular items do not stay in stock forever. ' +
        'Finish checking out now and it is yours.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('16'),
      image('https://placehold.co/240x240.png?text=$product_name', {
        width: '240',
        alignment: 'center',
        borderRadius: '12',
        link: 'https://nimbusstore.example/cart'
      }),
      spacer('8'),
      heading('$product_name', {
        fontSize: '18',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingBottom: '2'
      }),
      text('Back in your bag and ready to ship. Complete your order in under a minute.', {
        color: '#8a94a6',
        fontSize: '13',
        alignment: 'center',
        lineHeight: '1.6',
        paddingLeft: '40',
        paddingRight: '40'
      }),
      spacer('14'),
      button('Complete your purchase', 'https://nimbusstore.example/checkout', {
        backgroundColor: '#f97316',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '34',
        buttonPaddingV: '15'
      }),
      spacer('12'),
      text(
        '<strong style="color:#f97316;">Hurry</strong> — items in your bag are not reserved, and stock is limited.',
        { color: '#5b6472', fontSize: '13', alignment: 'center', lineHeight: '1.6', backgroundColor: '#fff7ed', paddingTop: '12', paddingBottom: '12' }
      ),
      spacer('18'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  },

  {
    id: 'ecommerce-product-recommendations',
    category: 'ecommerce',
    name: 'Product Recommendations',
    description: 'A personalized picks grid with three products, each with an image and View button.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        logoAlignment: 'left',
        backgroundColor: '#ffffff',
        linkColor: '#5b6472',
        links: [
          { id: 'l1', kind: 'link', label: 'New', url: 'https://nimbusstore.example/new' },
          { id: 'l2', kind: 'link', label: 'Shop', url: 'https://nimbusstore.example/shop' },
          { id: 'l3', kind: 'link', label: 'Sale', url: 'https://nimbusstore.example/sale' }
        ],
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('Picked just for you', '7c3aed', 'ffffff', {}),
      heading('Picked just for you, $first_name', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '28',
        paddingBottom: '8'
      }),
      text(
        'Based on what you have been browsing, we thought you would love these. Fresh arrivals, hand-selected for your style.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('18'),
      columns([
        [
          image('https://placehold.co/180x180.png?text=Aurora+Speaker', {
            width: '100',
            alignment: 'center',
            borderRadius: '10',
            link: 'https://nimbusstore.example/p/aurora-speaker'
          }),
          heading('Aurora Bluetooth Speaker', {
            fontSize: '15',
            fontWeight: '700',
            alignment: 'center',
            color: '#1b2333',
            paddingTop: '10',
            paddingBottom: '2'
          }),
          text('<strong>$89.00</strong>', { color: '#5b6472', fontSize: '13', alignment: 'center' }),
          button('View', 'https://nimbusstore.example/p/aurora-speaker', {
            backgroundColor: '#2563eb',
            textColor: '#ffffff',
            borderRadius: '6',
            fontSize: '13',
            alignment: 'center',
            buttonPaddingH: '22',
            buttonPaddingV: '10'
          })
        ],
        [
          image('https://placehold.co/180x180.png?text=Trail+Backpack', {
            width: '100',
            alignment: 'center',
            borderRadius: '10',
            link: 'https://nimbusstore.example/p/trail-backpack'
          }),
          heading('Trail 24L Backpack', {
            fontSize: '15',
            fontWeight: '700',
            alignment: 'center',
            color: '#1b2333',
            paddingTop: '10',
            paddingBottom: '2'
          }),
          text('<strong>$74.00</strong>', { color: '#5b6472', fontSize: '13', alignment: 'center' }),
          button('View', 'https://nimbusstore.example/p/trail-backpack', {
            backgroundColor: '#2563eb',
            textColor: '#ffffff',
            borderRadius: '6',
            fontSize: '13',
            alignment: 'center',
            buttonPaddingH: '22',
            buttonPaddingV: '10'
          })
        ],
        [
          image('https://placehold.co/180x180.png?text=Nimbus+Watch', {
            width: '100',
            alignment: 'center',
            borderRadius: '10',
            link: 'https://nimbusstore.example/p/nimbus-watch'
          }),
          heading('Nimbus Smart Watch', {
            fontSize: '15',
            fontWeight: '700',
            alignment: 'center',
            color: '#1b2333',
            paddingTop: '10',
            paddingBottom: '2'
          }),
          text('<strong>$149.00</strong>', { color: '#5b6472', fontSize: '13', alignment: 'center' }),
          button('View', 'https://nimbusstore.example/p/nimbus-watch', {
            backgroundColor: '#2563eb',
            textColor: '#ffffff',
            borderRadius: '6',
            fontSize: '13',
            alignment: 'center',
            buttonPaddingH: '22',
            buttonPaddingV: '10'
          })
        ]
      ]),
      spacer('18'),
      button('See all recommendations', 'https://nimbusstore.example/for-you', {
        backgroundColor: '#7c3aed',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '30',
        buttonPaddingV: '14'
      }),
      spacer('18'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  },

  {
    id: 'ecommerce-review-request',
    category: 'ecommerce',
    name: 'Review Request',
    description: 'Asks the shopper to rate a recent purchase with a quick star-rating CTA.',
    blocks: [
      HEADER,
      hero('We value your feedback', 'f59e0b', '1b2333', {}),
      heading('How did we do, $first_name?', {
        fontSize: '26',
        fontWeight: '700',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '28',
        paddingBottom: '8'
      }),
      text(
        'You recently received your <strong>$product_name</strong> from order <strong>#$order_id</strong>. ' +
        'We would love to hear what you think — your honest review helps other shoppers and helps us get better.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('14'),
      text(
        '<span style="font-size:30px;letter-spacing:6px;color:#f59e0b;">&#9733; &#9733; &#9733; &#9733; &#9733;</span>',
        { color: '#f59e0b', fontSize: '30', alignment: 'center', lineHeight: '1.2', backgroundColor: '#fffbeb', paddingTop: '14', paddingBottom: '8' }
      ),
      text('Rate your $product_name', { color: '#8a94a6', fontSize: '13', alignment: 'center', paddingBottom: '4' }),
      spacer('12'),
      button('Leave a review', 'https://nimbusstore.example/review/$order_id', {
        backgroundColor: '#f59e0b',
        textColor: '#1b2333',
        borderRadius: '8',
        fontSize: '15',
        alignment: 'center',
        buttonPaddingH: '32',
        buttonPaddingV: '14'
      }),
      spacer('16'),
      text(
        'It takes less than a minute, and as a thank-you you will get an exclusive discount code for your next order.',
        { color: '#5b6472', fontSize: '13', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('18'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  },

  {
    id: 'ecommerce-flash-sale',
    category: 'ecommerce',
    name: 'Flash Sale',
    description: 'A bold limited-time percentage-off promotion with a strong Shop now CTA.',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline',
        logoAlignment: 'left',
        backgroundColor: '#0b1020',
        linkColor: '#c7d0e0',
        links: [
          { id: 'l1', kind: 'link', label: 'Shop', url: 'https://nimbusstore.example/shop' },
          { id: 'l2', kind: 'link', label: 'Deals', url: 'https://nimbusstore.example/sale' },
          { id: 'l3', kind: 'link', label: 'Help', url: 'https://nimbusstore.example/help' }
        ],
        paddingTop: 18,
        paddingBottom: 18
      }),
      hero('48 HOURS ONLY — 40% OFF', 'e11d48', 'ffffff', {}),
      heading('$first_name, the Flash Sale is ON', {
        fontSize: '28',
        fontWeight: '800',
        alignment: 'center',
        color: '#1b2333',
        paddingTop: '26',
        paddingBottom: '6'
      }),
      text(
        'For the next <strong>48 hours only</strong>, take <strong style="color:#e11d48;">40% off</strong> everything site-wide. ' +
        'No code needed — the discount is applied automatically at checkout.',
        { color: '#5b6472', fontSize: '15', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('10'),
      text(
        '<span style="display:inline-block;background:#fde68a;color:#92400e;font-weight:700;padding:8px 16px;border-radius:999px;">' +
        'Ends midnight Sunday</span>',
        { color: '#92400e', fontSize: '13', alignment: 'center' }
      ),
      spacer('14'),
      button('Shop now', 'https://nimbusstore.example/sale', {
        backgroundColor: '#e11d48',
        textColor: '#ffffff',
        borderRadius: '8',
        fontSize: '16',
        alignment: 'center',
        buttonPaddingH: '40',
        buttonPaddingV: '16'
      }),
      spacer('16'),
      text(
        'Best sellers are already selling fast — once they are gone, they are gone. Do not miss your favorites at these prices.',
        { color: '#8a94a6', fontSize: '13', alignment: 'center', lineHeight: '1.6', paddingLeft: '32', paddingRight: '32' }
      ),
      spacer('18'),
      divider(),
      social({ alignment: 'center', iconColor: '#5b6472', backgroundColor: '#ffffff' }),
      FOOTER
    ]
  }
]

export default TEMPLATES
